import styled from 'styled-components';

interface HeaderProps {
  hasToken: boolean;
}

export const Container = styled.div<HeaderProps>`
  display: ${(props) => (props.hasToken ? 'flex' : 'none')};
  justify-content: space-between;
  // padding: 0.3% 2%;

  * {
    display: flex;
    align-items: center;

    // &:hover {
    //   cursor: pointer;
    // }
  }
`;
